import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('admin/manage-menu?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('admin/manage-menu/show/'+id);
    },    
    create(params) {
        return Service().post('admin/manage-menu/create', params);
    },
    update(id, params) {
        return Service().post('admin/manage-menu/update/'+id, params);
    },
    delete(id) {
        return Service().post('admin/manage-menu/delete/'+id);
    }
}